import { useEffect } from 'react';
import { useLocation } from 'react-router';

import {
  getRole,
  getUserRoleIds,
  removeRole,
  Roles,
  setActiveRole,
  setUserRoleIds,
} from 'api/tokenStorage';
import { queryClient } from 'app/queryClient';
import { isAuthSessionActive, useAuthSession } from 'hooks/useAuthSession';
import { chatKeys } from 'modules/ChatV2/api/queries';
import { isProfileType, resolveProfileType } from 'utils/resolveProfileType';

/** Keeps role helper cookies aligned with the server session (fixes stale/invalid myTeacherRole). */
export const useSyncRoleFromSession = () => {
  const { pathname } = useLocation();
  const { data: session } = useAuthSession();

  useEffect(() => {
    if (!isAuthSessionActive(session)) {
      return;
    }

    const roles = session?.roles ?? [];
    if (roles.length === 0) {
      return;
    }

    const cookieRole = getRole();
    if (cookieRole && !isProfileType(cookieRole)) {
      removeRole();
    }

    const cookieRoleId =
      cookieRole === 'tutor' ? Roles.tutor : cookieRole === 'student' ? Roles.student : null;
    if (cookieRoleId != null && roles.length > 0 && !roles.includes(cookieRoleId)) {
      removeRole();
      void queryClient.invalidateQueries({ queryKey: chatKeys.all });
    }

    if (isProfileType(getRole())) {
      if (!getUserRoleIds().length) {
        setUserRoleIds(roles);
      }
      return;
    }

    const profileType = resolveProfileType({ sessionRoles: roles, pathname });
    if (!profileType) {
      return;
    }

    setActiveRole(profileType === 'tutor' ? Roles.tutor : Roles.student);
    setUserRoleIds(roles);
  }, [session, pathname]);
};
